/**
 * @namespace {BX.UI}
 */
export default class ProgressBarStatus
{
	static COUNTER = "COUNTER";
	static PERCENT = "PERCENT";
	static NONE = "NONE";
}
